import type { GrantRole, OrgUser } from "./types"

export const MAX_VISIBLE_AVATARS = 5

export const AVATAR_COLORS = [
  { bg: "bg-colors-violet-100", text: "text-colors-violet-800" },
  { bg: "bg-colors-blue-100", text: "text-colors-blue-800" },
  { bg: "bg-colors-emerald-100", text: "text-colors-emerald-800" },
  { bg: "bg-colors-amber-100", text: "text-colors-amber-800" },
  { bg: "bg-colors-rose-100", text: "text-colors-rose-800" },
  { bg: "bg-colors-cyan-100", text: "text-colors-cyan-800" },
  { bg: "bg-colors-orange-100", text: "text-colors-orange-800" },
  { bg: "bg-colors-teal-100", text: "text-colors-teal-800" },
  { bg: "bg-colors-pink-100", text: "text-colors-pink-800" },
  { bg: "bg-colors-indigo-100", text: "text-colors-indigo-800" },
]

export function hashNameToColor(name: string) {
  let hash = 0
  for (let i = 0; i < name.length; i++) {
    hash = (hash * 31 + name.charCodeAt(i)) & 0xffffffff
  }
  return AVATAR_COLORS[Math.abs(hash) % AVATAR_COLORS.length]
}

function capitalize(s: string) {
  return s.charAt(0).toUpperCase() + s.slice(1).toLowerCase()
}

export function getDisplayName(user: OrgUser) {
  const parts = [user.firstName, user.lastName].filter(Boolean).map(p => capitalize(p!))
  return parts.length > 0 ? parts.join(" ") : (user.email ?? user.userId)
}

export function teamMemberCountLabel(memberCount: number) {
  return memberCount === 1 ? "1 member" : `${memberCount} members`
}

export function getInitials(user: OrgUser) {
  const first = user.firstName?.[0] ?? ""
  const last = user.lastName?.[0] ?? ""
  return (first + last).toUpperCase() || (user.email?.[0]?.toUpperCase() ?? "?")
}

export const ROLE_LABEL: Record<GrantRole, string> = {
  viewer: "Viewer",
  editor: "Editor",
}

export function roleLabel(role: GrantRole) {
  return ROLE_LABEL[role]
}
